export default {
      id: "icon-search-usage",
      viewBox: "0 0 28.527 28.514",
      url: __webpack_public_path__ + "icons.svg#icon-search",
      toString: function () {
        return this.url;
      }
    }